import React, { useState } from 'react';
import { ILog } from 'core/interfaces/IIncidents';
import { DialogModalFrame, Grid, Para, Theme } from 'uie/components';
import ActionHasSlo from '../ActionHasSlo';
import { Locale } from 'core/helpers/dateUtils';
import useUINavigationFunctionsV2 from 'views/main/organization/navigation-flows/useUINavigationFunctionV2';
import { IActivityMessages } from 'views/main/organization/navigation-flows/helpers';
import { IAppState } from 'core/interfaces/IAppState';
import ActivityIcon from '../ActivityIcon';
import ServiceNowMessages from './ServiceNowMessages';
import MessageBasedonAction from './messageBasedonAction/MessageBasedOnAction';
import MessageBasedonActionType from './messageBasedonActionType/MessageBasedonActionType';
import MessageBasedOnMultipleAction from './messageBasedOnMultipleAction/MessageBasedOnMultipleAction';
import { Box, HStack, Tooltip } from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from 'icons';
import { IconButton } from 'library/atoms/IconButton';
import { useManualActivityTimelineUpdate } from '../manualActivityEntryModal/hook';
import ConfirmModal from 'components/confirm.modal';

const ActivityMessages: React.FC<IActivityMessages & Pick<IAppState, 'organization'>> = ({
  incident,
  organization,
  logs,
  oUser,
  statusPages,
  setFocusMessageId,
  openEditModal,
}) => {
  const { theme } = Theme;
  const [showDeleteManualEntryModal, setShowDeleteManualEntryModal] = useState<boolean>(false);
  const toggleManualEntryMondal = () => {
    setShowDeleteManualEntryModal(!showDeleteManualEntryModal);
  };

  const { getDetailsFromLogActivity } = useUINavigationFunctionsV2(organization);
  const [idTobeDeleted, setIdTobeDeleted] = useState<string | undefined>(undefined);

  const { deleteEntry, deletingEntry } = useManualActivityTimelineUpdate(incident.id);

  const deleteEntryHandler = () => {
    if (idTobeDeleted) {
      deleteEntry(idTobeDeleted, () => {
        setIdTobeDeleted(undefined);
        toggleManualEntryMondal();
      });
    }
  };

  return (
    <Box
      className="mt-10"
      style={{
        overflow: 'auto',
        width: '100%',
      }}
    >
      {logs.map((log: ILog, index) => {
        if (log.action === 'Comment') return null;
        if (log.action === 'note_created') return null;

        const userName = oUser[log.id] || '';
        const { logMessageActivity, entityComponent, logChanges } = getDetailsFromLogActivity(log);
        const data = {
          log: log,
          logMessageActivity: logMessageActivity,
          entityComponent: entityComponent,
        };
        return (
          <Grid
            style={
              log.is_manually_created
                ? { backgroundColor: '#F3F9FF', marginBottom: 5, padding: 10, borderRadius: 5 }
                : {}
            }
            key={index}
          >
            <Grid flexWidth={12} className="verticalLine" alignItems="flex-start">
              <ActivityIcon log={log} />
              <Grid type="column" className="ml-10">
                <ActionHasSlo logChanges={logChanges} {...data} />
                <ServiceNowMessages log={log} />

                <MessageBasedonAction
                  setFocusMessageId={setFocusMessageId}
                  statusPages={statusPages}
                  userName={userName}
                  data={data}
                />
                <MessageBasedonActionType {...data} />

                {/* add your messages either in  MessageBasedonAction or  MessageBasedonActionType*/}
                {/* if your messages need  multiple action/actionType validation use  MessageBasedOnMultipleAction*/}

                {/* If your message is shown different in UI check useUINavigationFunctionV2 - getDetailsFromLogActivity */}
                <MessageBasedOnMultipleAction
                  incident={incident}
                  organization={organization}
                  {...data}
                />
                <Para fontSize={12} color={theme.shades.grey} className="mb-10">
                  {Locale.toFullDateTime(log.time)}
                </Para>
                {log.is_manually_created && (
                  <HStack spacing={3} padding={1}>
                    <Tooltip hasArrow placement="bottom" label={'Edit'} zIndex={'inherit'}>
                      <IconButton
                        aria-label="Filter"
                        variant="header"
                        style={{ height: '24px', width: '24px' }}
                        icon={<EditIcon height={10} width={10} />}
                        onClick={() => {
                          openEditModal(
                            log.reason,
                            log.time,
                            log.id,
                            log.should_show_in_postmortem,
                          );
                        }}
                        isDisabled={false}
                      />
                    </Tooltip>
                    <Tooltip hasArrow placement="bottom" label={'Delete'} zIndex={'inherit'}>
                      <IconButton
                        aria-label="Filter"
                        variant="header"
                        style={{ height: '24px', width: '24px' }}
                        icon={<DeleteIcon height={10} width={10} color="red" />}
                        onClick={() => {
                          setIdTobeDeleted(log.id);
                          toggleManualEntryMondal();
                          //  deleteEntryHandler(log.id);
                        }}
                        isLoading={deletingEntry && log.id === idTobeDeleted}
                        isDisabled={false}
                      />
                    </Tooltip>
                  </HStack>
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
      <DialogModalFrame
        id="organization_team_settings__delete_role"
        onClose={toggleManualEntryMondal}
        width="400px"
      >
        {showDeleteManualEntryModal && (
          <ConfirmModal
            header="Delete Timeline Item"
            displayText={
              <div>
                <div className="mt-5">
                  Are you sure you want to proceed with deletion of this manual update to the
                  timeline
                </div>
              </div>
            }
            buttonText="Delete"
            primaryButtonColor={theme.danger.default}
            cancelText="Cancel"
            isBusy={deletingEntry}
            hide={() => deleteEntryHandler()}
          />
        )}
      </DialogModalFrame>
    </Box>
  );
};

export default ActivityMessages;
